// Sample data for delivery reports visualization
export const getFakeDeliveryData = () => {
  return {
    // Data for DeliveryTrendChart
    deliveryTrendData: generateDeliveryTrendData(),

    // Data for DriverPerformanceStats
    driversData: generateDriversData(),

    // Data for DeliveryServiceStats
    serviceData: generateServiceData(),

    // Data for LateOrdersStats
    lateOrdersData: generateLateOrdersData(),

    // Data for DeliveryTeamStats
    teamStatsData: generateTeamStatsData(),

    // Data for OrderDistributionChart
    orderDistributionData: generateOrderDistributionData(),
  };
};

// Generate 30 days of delivery trend data
function generateDeliveryTrendData() {
  const data = [];
  const currentDate = new Date();

  for (let i = 29; i >= 0; i--) {
    const date = new Date(currentDate);
    date.setDate(date.getDate() - i);

    // Generate more realistic patterns: higher on weekends, lower on Mondays
    const dayOfWeek = date.getDay(); // 0 = Sunday, 6 = Saturday
    const isWeekend = dayOfWeek === 0 || dayOfWeek === 6;
    const isMonday = dayOfWeek === 1;

    const baseInHouse = isWeekend ? 65 : isMonday ? 35 : 50;
    const baseThirdParty = isWeekend ? 85 : isMonday ? 45 : 65;
    const baseAvgTime = isWeekend ? 36 : 32;

    // Add some randomness
    const inHouseDrivers = Math.floor(baseInHouse + Math.random() * 25 - 10);
    const thirdParty = Math.floor(baseThirdParty + Math.random() * 30 - 15);
    const avgTime = Math.floor(baseAvgTime + Math.random() * 8 - 4);

    data.push({
      date: date.toISOString().split("T")[0],
      inHouseDrivers,
      thirdParty,
      avgTime,
    });
  }

  return data;
}

// Generate driver performance data
function generateDriversData() {
  const driverNames = [
    "João Silva",
    "Maria Oliveira",
    "Carlos Pereira",
    "Ana Santos",
    "Luiz Costa",
    "Fernanda Lima",
    "Roberto Alves",
    "Juliana Martins",
    "Bruno Sousa",
    "Camila Ferreira",
    "Marcos Rodrigues",
    "Patricia Gomes",
  ];

  return driverNames.map((name) => {
    // Generate realistic delivery counts with some variation
    const deliveryCount = Math.floor(Math.random() * 180) + 40;

    return {
      driverName: name,
      deliveryCount,
    };
  });
}

// Generate delivery service data
function generateServiceData() {
  return [
    { serviceName: "Entregadores Próprios", orderCount: 1240 },
    { serviceName: "Disk Motos Rápidas", orderCount: 860 },
    { serviceName: "Motoboy Express", orderCount: 620 },
    { serviceName: "Delivery Flash", orderCount: 410 },
    { serviceName: "Logística Urbana", orderCount: 290 },
    { serviceName: "Outros", orderCount: 180 },
  ];
}

// Generate late orders data
function generateLateOrdersData() {
  return {
    totalLateOrders: 327,
    latePercentage: 4.2,
    avgLateTime: 18,
    percentChange: -2.7,
    reasons: [
      { reason: "Trânsito", count: 112 },
      { reason: "Chuva/Clima", count: 86 },
      { reason: "Entregador Atrasado", count: 45 },
      { reason: "Pedido Errado", count: 32 },
      { reason: "Problema no App", count: 28 },
      { reason: "Endereço Incorreto", count: 24 },
    ],
  };
}

// Generate delivery team stats
function generateTeamStatsData() {
  return {
    totalDrivers: 32,
    avgOrdersPerDriver: 113.5,
  };
}

// Generate order distribution data
function generateOrderDistributionData() {
  const regions = [
    "Centro",
    "Zona Sul",
    "Zona Norte",
    "Zona Leste",
    "Zona Oeste",
    "Jardins",
    "Moema",
    "Itaim",
    "Pinheiros",
    "Vila Mariana",
  ];

  return regions.map((region) => {
    // Create different patterns for different regions
    let morningBase = 30;
    let afternoonBase = 45;
    let eveningBase = 65;
    let nightBase = 15;

    // Downtown has more lunch orders, residential areas have more dinner
    if (region === "Centro") {
      afternoonBase = 85;
      eveningBase = 35;
    } else if (["Zona Sul", "Zona Oeste", "Jardins"].includes(region)) {
      eveningBase = 95;
    }

    return {
      region,
      morning: Math.floor(morningBase + Math.random() * 20),
      afternoon: Math.floor(afternoonBase + Math.random() * 25),
      evening: Math.floor(eveningBase + Math.random() * 30),
      night: Math.floor(nightBase + Math.random() * 15),
    };
  });
}
